import { DashboardReportOptions } from "../../../api/model/dashboard/DashboardReportOptions";

const getReportPagedJsStyle = (reportOptions: DashboardReportOptions) => {
  return {
    [window.location.href]: `@page {
                size: ${reportOptions!!.pageLayout?.format?.pageSize ?? "A4"} ${(reportOptions!!.pageLayout?.format?.orientation ?? "PORTRAIT").toLowerCase()};
                margin-top: ${reportOptions!!.pageLayout?.margins?.top ?? "20mm"};
                margin-bottom: ${reportOptions!!.pageLayout?.margins?.bottom ?? "20mm"};
                margin-left: ${reportOptions!!.pageLayout?.margins?.left ?? "20mm"};
                margin-right: ${reportOptions!!.pageLayout?.margins?.right ?? "20mm"};
                padding-top: ${reportOptions!!.pageLayout?.paddings?.top ?? "0"};
                padding-bottom: ${reportOptions!!.pageLayout?.paddings?.bottom ?? "0"};
                padding-left: ${reportOptions!!.pageLayout?.paddings?.left ?? "0"};
                padding-right: ${reportOptions!!.pageLayout?.paddings?.right ?? "0"};
            }
            .report-tab-break {
                 break-before: page;
                 page-break-before: always;
      }
    `,
  };
};

export default getReportPagedJsStyle;
